import { useTranslation } from 'gatsby-plugin-react-i18next'
import { getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

import Link from '../Atoms/Link';
import { ImageGatsby } from '../Atoms/Image';
import ArrowButton from '../Atoms/ArrowButton';

import footerData from './footer.json';
import legalLinksData from './legal.json';

const imageQuery = graphql`
  query {
    footerImage: file(relativePath: { eq: "footer.png" }) {
      childImageSharp {
        gatsbyImageData (width: 445)
      }
    }
    logo: file(base: {eq: "logo.svg"}) {
      publicURL
    }
    authenticity: file(base: {eq: "authenticity.svg"}) {
      publicURL
    }
    security: file(base: {eq: "security.svg"}) {
      publicURL
    }
    trust: file(base: {eq: "trust.svg"}) {
      publicURL
    }
    paymentGuaranteed: file(base: {eq: "payment-guaranteed.svg"}) {
      publicURL
    }
  }
`;

const Footer = ({ footerColor = 'bg-gray-100' }) => {
  const { t } = useTranslation();
  const { footerImage, logo, authenticity, security, trust, paymentGuaranteed } = useStaticQuery(imageQuery);

  return (
    <footer className={`pt-40 ${footerColor}`}>
      <div className="p-10 sm:p-16 sm:pb-10 md:pr-36 flex flex-col bg-blue">
        <div className="md:grid gap-5 grid-cols-3 relative">
          <div className="">
            <ImageGatsby image={getImage(footerImage)} alt="footer" className="md:-mt-60 -mt-40 block lg:hidden xl:block" />
          </div>
          <div className="flex flex-col col-span-3 xl:col-span-2">
            <p className="text-lg md:text-xl font-cirka mb-6 text-gray-400">{t('footer.subtitle')}</p>
            <h2 className="text-4xl md:text-6xl font-cirka text-primary mb-12">{t('footer.title')}</h2>
            <form action="/" className="mb-10 md:mb-14">
              <div className="flex items-center mb-7">
                <input type="text" placeholder={t('footer.emailPlaceholder') || ''} className="bg-transparent text-gray-400 border-primary border placeholder-gray-400 py-4 px-5 mr-5 font-roboto w-5/6" />
                <button type="button" aria-label='submit'>
                  <ArrowButton isGhost={false} />
                </button>
              </div>
              <label className="font-roboto text-xs md:text-sm text-gray-400 flex items-center">
                <input type="checkbox" required className="h-5 w-5 border border-gray-50 mr-5" />
                {t('footer.checkboxLabel')}
              </label>
            </form>
            <div className="flex justify-between mb-8 pr-10 flex-wrap-reverse">
              {footerData.map(item => (
                <div key={`footer-${item.title}`}>
                  <h3 className="font-cirka text-base md:text-xl mb-8 text-gray-400 mt-5 md:mt-0">{t(item.title)}</h3>
                  {item.links.map(link => (
                    <Link to={link.url} key={`${link.name}-${link.url}`} className="block text-sm md:text-base font-roboto font-light text-primary p-2">
                      {t(link.name)}
                    </Link>
                  ))}
                </div>
              ))}
            </div>
            <div>
              <h3 className="text-xl font-cirka mb-7 text-gray-400">{t('footer.paymentMethods')}</h3>
              <div className="flex">
                <div className="text-gray-400 md:leading-2 uppercase font-roboto font-light text-xs text-center border p-3 rounded ">
                  {t('footer.banktransfer')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col-reverse md:flex-row items-center md:flex-wrap-reverse">
          <hr className="h-px w-full order-1 md:order-10 mb-4 border-0" style={{
            backgroundImage: 'linear-gradient(to right, #A38D70 40%, rgba(255, 255, 255, 0) 20%)',
            backgroundSize: '8px 1px'
          }} />
          <div className="flex mt-6 md:mt-0">
            <img src={trust.publicURL} alt="Trust" className="h-16 w-16 sm:h-20 sm:w-20 mr-5" loading="lazy" />
            <img src={paymentGuaranteed.publicURL} alt="Payment Guaranteed" className="h-16 w-16 sm:h-20 sm:w-20 mr-5" loading="lazy" />
            <img src={authenticity.publicURL} alt="Authenticity" className="h-16 w-16 sm:h-20 sm:w-20 mr-5" loading="lazy" />
            <img src={security.publicURL} alt="Security" className="h-16 w-16 sm:h-20 sm:w-20 mr-5" loading="lazy" />
          </div>
          <div className="flex-grow ml-4">
            {legalLinksData.map((item, index) => (
              <Link to={item.url} key={`${item.name}-${item.url}`} className={`text-primary font-roboto font-light text-xs p-4 ${index !== 0 && 'border-l border-primary'}`}>{t(item.name)}</Link>
            ))}
          </div>
          <img src={logo.publicURL} alt="logo" className="hidden md:block h-10" loading="lazy" />
        </div>
      </div>
    </footer>
  )
}

export default Footer
